// Surfaces that operate on user-real state and become confusing/broken when the
// active workspace is a demo or public preview. Used to (a) disable rail tiles
// while a preview is active, (b) redirect deep-links back to Dashboard, and
// (c) hide preview workspaces from the switcher while one of these views is
// showing (the user must be able to switch only into real member workspaces).
export const USER_SURFACES_REQUIRE_REAL_WORKSPACE: ReadonlySet<string> = new Set([
  'EXPLORE',
  'PURCHASE',
  'USER_SETTINGS',
])

export const viewRequiresRealWorkspace = (view: string): boolean =>
  USER_SURFACES_REQUIRE_REAL_WORKSPACE.has(view)
